import { SettingConst } from '@faire/web-api--source/types';

/**
 * Controls natural language search feature that selectively converts raw query strings into a combination of a
 * new query term and filters through LLM
 */
export const ENABLE_NATURAL_LANGUAGE_SEARCH_MVP_250501 =
  'ENABLE_NATURAL_LANGUAGE_SEARCH_MVP_250501' as SettingConst<
    'ENABLE_NATURAL_LANGUAGE_SEARCH_MVP_250501',
    boolean,
    'RETAILER'
  >;
